import React, { useState } from "react";
import "../../../Assets/css/cbLabGrown.css";
import { Col, Container, Form, Image, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import {
  Address_details,
  base_url,
  media_details,
  postHeader,
} from "../../../Helpers/request";
import swal from "sweetalert";
import { useSelector } from "react-redux";
import DiamondImg from "../../../Assets/images/cultured-img/diamonds.png";
import DiamondBannerImg from "../../../Assets/images/cultured-img/diamond-banner.jpg";
import GrowingDiamondBannerImg from "../../../Assets/images/cultured-img/growing-pains.jpg";
import brilliantBannerImg from "../../../Assets/images/cultured-img/brilliant-choice.jpg";
import { NavLink, useHistory } from "react-router-dom";
import s1 from "../../../Assets/images/cultured-img/s1.png";
import s2 from "../../../Assets/images/cultured-img/S2.png";
import s3 from "../../../Assets/images/cultured-img/S3.png";
import s4 from "../../../Assets/images/cultured-img/s4.png";
import axios from "axios";

const CbLabGrown = () => {
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  const history = useHistory();

  const [first_name, setFirst_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [comment, setComment] = useState("");

  const formsubmit = (e) => {
    e.preventDefault();
    var data = {
      first_name,
      last_name,
      email,
      phone,
      comment,
    };
    axios
      .post(base_url + "/user/contact", data, {
        headers: postHeader,
      })
      .then((response) => {
        if (response.data.status == 1) {
          setFirst_name("");
          setLast_name("");
          setEmail("");
          setComment("");
          setPhone("");
          return swal(response.data.message, "", "success");
        } else {
          return swal(response.data.message, "", "error");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails.title}</title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
      </Helmet>
      <div className="cb_labd_Section">
        <div className="cb_lab_grown_page_Section">
          <div className="cb_labgrown_banner">
            <Container>
              <Row>
                <Col
                  sm={12}
                  md={8}
                  lg={6}
                  className="d-flex justify-content-center align-items-center p-0 order_1"
                >
                  <div className="cb_labgrown_banner_left_text">
                    <h1>Lab Created Diamonds In Atlanta</h1>
                    <p>
                      Our lab created diamonds are precious stones consisting of
                      a clear and colorless crystalline form of pure carbon.
                    </p>
                    <NavLink to="/diamonds/lab" className="cb_btn_white">
                      Browse Diamond Gallery
                    </NavLink>
                  </div>
                </Col>
                <Col
                  sm={12}
                  md={4}
                  lg={6}
                  className="d-flex justify-content-center align-items-center order_2"
                >
                  <div className="cb_banner_lab_right_img text-center">
                    <Image
                      src={DiamondImg}
                      alt="Diamond Image"
                      className="img-fluid"
                    />
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <div className="cb_a_lab_create_diamond_section">
          <Container fluid>
            <Row>
              <Col
                sm={12}
                md={12}
                lg={6}
                className="d-flex justify-content-center align-items-center p-0 order_1"
              >
                <div className="cb_lab_text_box_outer text-center">
                  <h2>A Lab Created Diamond is a Diamond</h2>
                  <p>
                    Laboratory created diamonds are chemically, physically and
                    optically identical to diamonds that are taken from the
                    earth. Truly identical, except for time to create and price
                    for the consumer.
                  </p>
                  <p>
                    Lab diamonds, aka “Cultured Diamonds”, can be grown from a
                    carbon seed by application of High Pressure and High
                    Temperature (HPHT). This treatment mimics the effects of
                    millions of years under the earth.
                  </p>
                  <p>
                    The carbon seed grows and then becomes compressed, hardening
                    into a diamond rough. The rough is then analyzed and cut
                    using the same process as mined diamonds.
                  </p>
                  <NavLink to="/diamonds/lab" className="cd_btn_rama_color">
                    View All
                  </NavLink>
                </div>
              </Col>
              <Col
                sm={12}
                md={12}
                lg={6}
                className="d-flex justify-content-center align-items-center p-0 order_2"
              >
                <div className="cb_banner_lab_right_img text-center">
                  <Image
                    src={DiamondBannerImg}
                    alt="Diamond Image"
                    className="img-fluid"
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col
                sm={12}
                md={12}
                lg={6}
                className="d-flex justify-content-center align-items-center p-0"
              >
                <div className="cb_banner_lab_right_img text-center">
                  <Image
                    src={GrowingDiamondBannerImg}
                    alt="Diamond Image"
                    className="img-fluid"
                  />
                </div>
              </Col>
              <Col
                sm={12}
                md={12}
                lg={6}
                className="d-flex justify-content-center align-items-center p-0"
              >
                <div className="cb_lab_text_box_outer text-center">
                  <h2>Growing Pains</h2>
                  <p>
                    Cultured diamonds have the same “growing pains” as mined
                    diamonds and will display the same color and clarity
                    variations. The International Gemological Institute (IGI)
                    grades lab created diamonds according to the same protocol
                    as mined diamonds. The Federal Trade Commission (FTC) has
                    validated the authenticity by changing the trade definition
                    of “diamond” to remove the requirement that it be “from the
                    earth”. The FTC also noted that it is permissible to refer
                    to laboratory created diamonds as “cultured diamonds”.
                    Compare this concept to cultured pearls. And, in early 2019,
                    the Gemological Institute of America announced that it will
                    be adding cultured diamonds to its list of certifications.
                  </p>
                  <NavLink to="/ringsettings" className="cd_btn_rama_color">
                    Diamond Ring Gallery
                  </NavLink>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div className="cb_choose_your_lab_created_diamond_section">
          <Container>
            <Row>
              <Col sm={12} md={12} lg={{ span: 7, offset: 5 }}>
                <div className="cb_lab_text_box_outer cb_width_80  text-center">
                  <h2>Choose Your Lab Created Diamonds</h2>
                  <p>
                    You can decide to purchase diamonds that were taken from the
                    earth by industrial methods and pay a premium for that
                    choice, or you can choose to purchase the same crystalline
                    form of pure carbon (aka “a diamond”) that is produced in a
                    safe, eco-friendly environment at a considerably more
                    affordable price.
                  </p>
                  <p>What will you choose?</p>
                  <NavLink to="/ringsettings" className="cb_btn_white">
                    Make Your Ring
                  </NavLink>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="cb_the_brilliant_choice_section">
          <Container fluid>
            <Row>
              <Col
                sm={12}
                md={12}
                lg={6}
                className="d-flex justify-content-center align-items-center p-0 order_1"
              >
                <div className="cb_lab_text_box_outer text-center">
                  <h2>The Brilliant Choice</h2>
                  <p>
                    We specialize in cultured diamonds. Not only do our diamonds
                    sparkle brilliantly, but so do our customers. Come shop our
                    store. Let us help you find your perfect cultured diamond.
                  </p>
                  <button
                    className="cd_btn_rama_color"
                    onClick={() => history.push("/make-an-appointment")}
                  >
                    Make An Appointment
                  </button>
                </div>
              </Col>
              <Col
                sm={12}
                md={12}
                lg={6}
                className="d-flex justify-content-center align-items-center p-0 order_2"
              >
                <div className="cb_banner_lab_right_img text-center">
                  <Image
                    src={brilliantBannerImg}
                    alt="Diamond Image"
                    className="img-fluid"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="cb_Diamond_Expert_section">
          <Container fluid>
            <Row>
              <Col
                sm={12}
                md={12}
                lg={6}
                className="d-flex justify-content-center align-items-center p-0"
              >
                <div className="cb_lab_text_box_outer text-center">
                  <h2>Talk To A Lab Created Diamond Expert</h2>
                  <p>
                    We specialize in custom engagements rings and wedding bands.
                    However, we also have connections with expert designers all
                    over the world, so we can find you the perfect ring even if
                    you aren’t looking for a custom option.
                  </p>
                  <p>
                    We just want to bring you the best diamond jewelry possible,
                    whether it’s designed in-house or procured from a talented
                    designer elsewhere. We guarantee that you won’t find a finer
                    engagement ring for a better price.
                  </p>
                  <a
                    className="cb_btn_white"
                    href="tel: +1 (678) 722-5664"
                    target="_blank"
                  >
                    Call Us
                  </a>
                </div>
              </Col>
              <Col
                sm={12}
                md={12}
                lg={6}
                className="d-flex justify-content-center align-items-center p-0"
              >
                <div className="rcs_myaccount_section cb_form_outer_box">
                  <div className="rcs">
                    <Container>
                      <h1 className="text-white">Send us a note</h1>
                      {/* news forms */}
                      <Form onSubmit={formsubmit}>
                        {/* full name */}
                        <Row>
                          <Col sm={12} md={6} lg={6}>
                            <Form.Group
                              className="mb-3"
                              controlId="exampleForm.ControlInput1"
                            >
                              <Form.Control
                                aria-label="First name"
                                id="outlined-basic"
                                placeholder="Full Name"
                                label="First Name"
                                type="text"
                                variant="outlined"
                                value={first_name}
                                onChange={(e) => setFirst_name(e.target.value)}
                                required
                              />
                            </Form.Group>
                          </Col>

                          {/* phone */}
                          <Col sm={12} md={6} lg={6}>
                            <Form.Group
                              className="mb-3"
                              controlId="exampleForm.ControlInput1"
                            >
                              <Form.Control
                                aria-label="Last name"
                                placeholder="Phone"
                                id="outlined-basic"
                                label="Phone"
                                type="number"
                                variant="outlined"
                                InputProps={{ inputProps: { min: 0 } }}
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                required
                              />
                            </Form.Group>
                          </Col>
                          {/* emaiul */}
                          <Col sm={12} md={12} lg={12}>
                            <Form.Group
                              className="mb-3"
                              controlId="exampleForm.ControlInput1"
                            >
                              <Form.Control
                                aria-label="Email"
                                id="outlined-basic"
                                placeholder="Email"
                                label="Email Address"
                                type="Email"
                                variant="outlined"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                              />
                            </Form.Group>
                          </Col>

                          {/* text area */}
                          <Col sm={12} md={12} lg={12}>
                            <Form.Group
                              className="mb-2"
                              controlId="exampleForm.ControlTextarea1"
                            >
                              <Form.Control
                                aria-label="message"
                                as="textarea"
                                id="filled-multiline-static"
                                label="Your Message"
                                multiline
                                rows={4}
                                variant="outlined"
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                              />
                            </Form.Group>
                          </Col>
                          <Col sm={12} md={12} lg={12}>
                            <button
                              variant="contained"
                              type="submit"
                              className="cb_btn_white"
                            >
                              {" "}
                              SEND
                            </button>
                          </Col>
                        </Row>
                      </Form>
                    </Container>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <div className='cb_shipping__home_Section'>
     <Container>
           <Row>
            <Col sm={12} md={3} lg={3}>
                <div className='cb_shipping_text_img first'>
                  <Image src={s1} alt="Shipping icon"/>
                    <h6>Free 2-days shipping</h6>
                </div>
            </Col>
            <Col sm={12} md={3} lg={3}>
                <div className='cb_shipping_text_img second'>
                <Image src={s2} alt="Shipping icon"/>
                    <h6>30-day no Hassle returns</h6>
                    <p>(Excludes Custom Work)</p>
                </div>
            </Col>
            <Col sm={12} md={3} lg={3}>
                <div className='cb_shipping_text_img third'>
                <Image src={s3} alt="Shipping icon"/>
                    <h6>CB concierge</h6>
                    <p>Complimentary White Glove Services</p>
                </div>
            </Col>
            <Col sm={12} md={3} lg={3}>
                <div className='cb_shipping_text_img third'>
                <Image src={s4} alt="Shipping icon"/>
                    <h6>CB Gives Back</h6>
                </div>
            </Col>
           </Row>
        </Container> 
      </div>

      
    </>
  );
};

export default CbLabGrown;
